// extracted by mini-css-extract-plugin
module.exports = {"error":"InputCheckbox--error","disabled":"InputCheckbox--disabled"};